import { useMemo } from 'react';
import type { AuditFacets } from '@/api/audit';
import { listAuditFacets } from '@/api/audit';
import { mockAuditLogs } from '@/data/mock-audit-data';
import { useApiQuery } from './useApiQuery';

const buildMockFacets = (): AuditFacets => ({
  actions: Array.from(new Set(mockAuditLogs.map((log) => log.action))).sort(),
  entityTypes: Array.from(
    new Set(mockAuditLogs.map((log) => log.entityType)),
  ).sort(),
});

interface UseAuditFacetsResult {
  actions: string[];
  entityTypes: string[];
}

export const useAuditFacets = (): UseAuditFacetsResult => {
  const mockFacets = useMemo(
    () => (import.meta.env.DEV ? buildMockFacets() : undefined),
    [],
  );

  const query = useApiQuery<AuditFacets>(
    {
      queryFn: () => listAuditFacets(),
      mockData: mockFacets,
    },
    [],
  );

  return {
    actions: query.data?.actions ?? [],
    entityTypes: query.data?.entityTypes ?? [],
  };
};
